import LogRocket from 'logrocket';
import env from '@/config/env';

let isInitialized = false;

const initializeLogRocket = () => {
  if (isInitialized) {
    return;
  }

  const appId =
    env.LOGROCKET_ID ??
    (typeof process !== 'undefined'
      ? process.env?.VITE_LOGROCKET_ID
      : undefined);
  if (!appId) {
    console.warn('LogRocket app ID not found in environment variables');
    return;
  }

  try {
    LogRocket.init(appId);
    isInitialized = true;
  } catch (error) {
    console.error('Failed to initialize LogRocket:', error);
  }
};

const identifyUser = ({ userIdentifier, additionalInfo }) => {
  try {
    LogRocket.identify(userIdentifier, additionalInfo);
  } catch (error) {
    console.error('Failed to identify user in LogRocket:', error);
  }
};

const setCustomProperty = (key, value) => {
  try {
    LogRocket.identify({ [key]: value });
  } catch (error) {
    console.error('Failed to set custom property in LogRocket:', error);
  }
};

const logEvent = (eventName, eventData = {}) => {
  try {
    LogRocket.track(eventName, eventData);
  } catch (error) {
    console.error('Failed to log event in LogRocket:', error);
  }
};

const captureException = (error) => {
  try {
    LogRocket.captureException(error);
  } catch (logRocketError) {
    console.error('Failed to capture exception in LogRocket:', logRocketError);
  }
};

const getSessionURL = () => {
  try {
    return LogRocket.sessionURL;
  } catch (error) {
    console.error('Failed to get LogRocket session URL:', error);
    return null;
  }
};

export {
  initializeLogRocket,
  identifyUser,
  setCustomProperty,
  logEvent,
  captureException,
  getSessionURL,
};
